import { render, staticRenderFns } from "./PainCareInfoModal.vue?vue&type=template&id=74d79ad0&scoped=true&"
import script from "./PainCareInfoModal.vue?vue&type=script&lang=js&"
export * from "./PainCareInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./PainCareInfoModal.vue?vue&type=style&index=0&id=74d79ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d79ad0",
  null
  
)

export default component.exports